// src/helpers/settings/schema.ts
var getSettingsGenericError = ({
  key,
  message,
  id,
  section
}) => ({
  [key]: {
    id: "genericError" /* GENERIC_ERROR */,
    data: {
      message
    },
    kind: {
      id,
      data: {
        message
      },
      type: "genericError" /* GENERIC_ERROR */,
      section
    }
  }
});

export { getSettingsGenericError };
